// extracted by mini-css-extract-plugin
module.exports = {"container":"mobile-session-module--container--1TL6A","red":"mobile-session-module--red--212ei"};